/* istanbul ignore file */
import { useFilterContext, DropDownFilter, FilterInputDecorator } from 'framework/list';
import { FilterCondition } from 'framework/types';
import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import { CandidateTimelineRecordTypeDropdown } from 'domain/recruiting/candidate/shared/timeline';
import { PersonTimelineFilterButtonLayout } from 'domain/shared/timeline';
import _ from 'lodash';
import { UiThemeOverrider } from 'framework/uiTheme';
import { CANDIDATE_TIMELINE_RECORDS_ALIAS } from 'domain/shared/candidate';

interface CandidateTimelineRecordTypeFilterProps {
  cleanableFilters: any[];
  source: string;
}

const CandidateTimelineRecordTypeFilter = ({
  cleanableFilters = [],
  source,
  ...props
}: CandidateTimelineRecordTypeFilterProps) => {
  const { filterBy, quickFilter, clearAndApplyFilter, filters: contextFilters } = useFilterContext();
  const [isChecked, setIsChecked] = useState(true);

  const defaultTimelineTypes: string[] = [CANDIDATE_TIMELINE_RECORDS_ALIAS.NOTE_CREATED];

  useEffect(() => {
    if (_.isEmpty(contextFilters?.type?.[FilterCondition.IN])) {
      setIsChecked(true);
    } else setIsChecked(false);
  }, [contextFilters]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;

    if (checked) {
      clearAndApplyFilter([...cleanableFilters, source]);
    } else {
      quickFilter({
        type: {
          [FilterCondition.IN]: defaultTimelineTypes,
        },
      });
    }
  };

  const onChangeCallback = (filter: any) => {
    const filters = {
      ...filter,
    };

    cleanableFilters.forEach((clearableFilter: string) => {
      filters[clearableFilter] = {};
    });

    filterBy(filters);
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Typography color="textSecondary">Show all activities</Typography>
        <Switch checked={isChecked} onChange={handleSwitchChange} size="small" />
      </Box>
      <UiThemeOverrider
        overriddenLayouts={{
          DropdownLayout: PersonTimelineFilterButtonLayout,
        }}
      >
        <DropDownFilter {...props} source={source} isSingle={false} onChangeCallback={onChangeCallback}>
          <FilterInputDecorator cleanableFilters={[...cleanableFilters, source]}>
            <CandidateTimelineRecordTypeDropdown {...props} />
          </FilterInputDecorator>
        </DropDownFilter>
      </UiThemeOverrider>
    </>
  );
};

export default CandidateTimelineRecordTypeFilter;
